export const faqs = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Unified Mobile Application for New-age Governance (UMANG), a Digital India initiative of Ministry of Electronics and Information Technology (MeitY) refers to the multiple government services being made accessible to you through UMANG mobile App, Website, SMS short code, and UMANG toll free IVR.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is the aim of UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The aim of UMANG is to fast-track mobile governance in India.',
      },
    },
    {
      '@type': 'Question',
      name: 'How will UMANG achieve its aim?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG intends to provide convenient accessibility of major services offered by Central and State Government departments, Local bodies and other utility services from private organizations. It provides a unified approach where you can install one application to avail multiple government services on multiple channels like mobile application, web, IVR and SMS which can be accessed through smartphones, feature phones, tablets and desktops.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is the utility of UMANG if I already have many government applications?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Availability of many department services on a single unified mobile app has more utility for you. With UMANG, you do not need to download multiple mobile apps for availing services of different central and state government departments.',
      },
    },
    {
      '@type': 'Question',
      name: 'How is UMANG better than installing individual mobile apps?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You do not need to install or update the app (again and again) to avail government services if more departments are added to the platform. UMANG provides a uniform experience across department services including payment-based transactions.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the security measures used in UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG uses latest industry standards as security measures such as MPIN  and OTP.\n\nApart from MPIN, the account recovery options such as security questions, alternate mobile number and email address ensure that the UMANG account details are never compromised. The account recovery options appear when you forget your MPIN.\n\nIn addition, your profile details are saved in encrypted format in the system so that no one can read these details. Further, you can manage the security settings in the app based on your device requirements. You can go to the Navigation Drawer > Settings > Account Settings or Navigation Drawer > My Profile > Account Settings to manage your Account settings.',
      },
    },
    {
      '@type': 'Question',
      name: 'I have lost my handset, what do I do?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You should immediately call us at our toll free number 10505 to avoid any misuse of your UMANG account.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I access my UMANG account, once blocked?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Once blocked, you will be forcefully logged out from all devices and you won’t be able to login. In order to login/re-activate your UMANG account, you will have to enter your registered mobile number and MPIN only after 24 hours.\n\nYou can also get your account unblocked by calling our customer support team at our toll free number 10505.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I delete my UMANG account?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Deleting account option can be found under Settings > Account Settings > Delete My UMANG Account. This will delete all your personal settings, UMANG account details, cache and your profiles will also be de-linked. You will no longer be allowed to login to this account. You will need to create a new UMANG account in order to access UMANG.  ',
      },
    },
    {
      '@type': 'Question',
      name: 'What “up time” can I expect from UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG does not guarantee the availability of department services offered by its Service Providers at all times as the availability of the services depend on several factors such as telecom network, Cloud Service Provider, and respective partner Service Providers. However, all efforts will be made to maintain the highest availability of services.',
      },
    },
    {
      '@type': 'Question',
      name: 'Who is a service provider on UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG provides major services offered by Central and State Government departments, Local bodies and other utility services from private organizations. Such entities providing these services have been referred as Service Providers.',
      },
    },
    {
      '@type': 'Question',
      name: 'Will UMANG provide multilingual support?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, UMANG supports 12 major Indian languages in addition to English.',
      },
    },
    {
      '@type': 'Question',
      name: 'How many services will be provided by UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG will provide major government services. The onboarding of different citizen-centric government services on UMANG is envisaged to be a continuous process that will result in increasing the number of such services on UMANG with the passage of time. UMANG is targeted to provide 200 applications with approximately 1200 services by December 2019. The services will be from various government departments of Centre, States, Local bodies and some private utility services.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I register on UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can register on UMANG through the following interfaces:\n\nWeb\nMobile App\nHowever, you do not need registration for using UMANG department services through IVR and SMS.\n\nYou can directly use the IVR number and SMS number to avail the UMANG department services available on SMS and IVR.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can a single UMANG account be used by multiple members?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, single UMANG account cannot be used by multiple members as you can use single mobile number as your registered mobile number and that number  cannot be used again to create another account unless the account linked with this number is deleted or registered mobile number is changed through settings and proper validation is done.',
      },
    },
    {
      '@type': 'Question',
      name: 'I have lost my phone, will my details be compromised?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, your details will not be compromised because MPIN validation is required for any service access or profile change. You can even contact customer support and block your account.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I login on UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can login using mobile number with MPIN (if set) or OTP. If you are not a registered user and trying to login, you will not be able to login. You need to go to the New User section and complete the registration process. If you find any difficulty in login or registration, you can check the network connectivity and can try after some time. For any assistance, you can call the UMANG customer care support at 10505.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I access UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can access UMANG through the following interfaces:\n\nWeb\nMobile App\nIVR\nSMS\n \n\nIf you are accessing the UMANG app or web interface, you must complete the registration process to avail UMANG department services.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I avail UMANG department services only through the mobile app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG department services can be primarily availed through UMANG mobile app or through UMANG website. However, particular department services may be made available on Pull SMS and IVR.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I access UMANG on my desktop?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can access UMANG from desktop using the UMANG website www.umang.gov.in.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I access state-wise department services on UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can access state-wise department services in UMANG by clicking on the State tab.\nAll department services related to the state selected by you are displayed on this screen.\nIf the user has not selected any State in profile, an option to select a state appears on this screen when the user accesses this tab for the first time.\nIn addition, users can access All, Central, and State department services by clicking on the All Services tab.',
      },
    },
    {
      '@type': 'Question',
      name: 'How much memory should be there on my mobile to download the UMANG app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The size of the UMANG mobile app is around 12-40 MB depending upon the operating system.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I download the UMANG app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG application is available on Android, Windows and iOS app stores. Just type UMANG in the search text box. The search results are displayed. In the search results, select the UMANG app from MeitY and download it.',
      },
    },
    {
      '@type': 'Question',
      name: 'What will be my mobile charges for using the UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You access UMANG on your mobile devices using the Internet/GPRS data connection or Wi-Fi. The data charges if any will be applicable as per your data plan.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I get information on using UMANG application?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To know about using UMANG application, you can access UMANG User Manual available in the Help & support section.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I update or modify my personal details?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To update the profile details:\n1.      Click the  icon.\n2.      Click the My Profile tab for adding personal details.\n3.      Click on UMANG profile.\n4.      Click Edit.\n5.      Edit the details.\n6.      Click Save.\n7.      Enter MPIN for updating the changes made in profile.\n8.      Click DONE.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does maintaining 100% updated profile help me?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Maintaining 100% updated profile enables you to:\n\nReceive relevant app suggestions, email communication and notifications.\nAuto-fill profile information wherever required while filling any department form or applying for service. UMANG profile is used to auto-fill any department form in app.',
      },
    },
    {
      '@type': 'Question',
      name: 'Who can view my profile details?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Your profile details can be viewed and authenticated by you and your service departments only.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I change my registered mobile number?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To change the mobile number:\n1.      Click the  icon.\n2.      Click on Settings.\n3.      Click on Account Settings.\n4.      Click on Change Registered Mobile Number.\n5.      Enter the MPIN.\n6.      Enter a new mobile number to be registered.\n7.      Validate the newly entered mobile number.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I link multiple mobile numbers for recovery?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can add an alternate mobile number for account recovery when you forget your MPIN.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I link my social account like Facebook and Twitter with UMANG profile?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can link your Twitter and Facebook accounts with UMANG profile. UMANG can also be linked with Google+.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I link the UMANG account with social profiles through the profile section?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To link the UMANG account with social profiles:\n1. Click the  icon.\n2. Click the My Profile tab.\n3. Click Social Media Accounts.\n4. Select Facebook, Google + or Twitter option and link specific account.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I delete my profile?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To delete the profile:\n1. Click the  icon.\n2. Click the Settings tab.\n3. Click on Account Settings.\n4. Click Delete My UMANG Account. A confirmation message appears.\n5. Click ok if you want to proceed with the deletion.\n6. Enter the MPIN.\n7. Click the next icon. A confirmation message appears again.\n8. Your account is successfully deleted.',
      },
    },
    {
      '@type': 'Question',
      name: 'What happens to my deleted profile?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Your data is deleted from the UMANG system when you delete your profile.\n\nIf you have deleted your profile, you have to again sign up as a new user in the UMANG to avail the services again and all of your previous data shall be erased.',
      },
    },
    {
      '@type': 'Question',
      name: 'After deleting my profile, can I login again with the same credentials?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, after deleting your profile, you cannot login. You have to register as a new user and again fill in your details to login again.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I stop receiving SMS and emails from UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, you cannot stop receiving SMS and emails from UMANG. You need to delete your account from UMANG to stop receiving the notifications.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I stop receiving emails and SMS communication from UMANG?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG sends only relevant and important communication to you through SMS and email. However, if you want to stop receiving these emails and SMS, you need to delete your account from UMANG.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is MPIN and why do I need to set the MPIN?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'MPIN stands for "Mobile Personal Identification Number."\n\nIt is a personal code that acts as your password for accessing UMANG. MPIN is invoked for login, payments, change requests, and profile change transactions to ensure authenticity.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need MPIN to edit any profile information?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you need to authenticate your credentials using MPIN to edit your profile information.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is the process of changing MPIN?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To change the MPIN:\n\n1. Click the  icon.\n2. Click Settings.\n3. Click Account Settings.\n4. Click Change MPIN.\n5. Enter the following details:\n–  Old MPIN\n–  New MPIN\n–  New MPIN for confirmation\n6. Click the next icon.\n7. Once MPIN is changed you will be logged out from all the devices and need to login again.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I change my home page to any other page?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can select another app page as your Home page.\n\nTo change the Home page:\n1. Click the  icon.\n2. Click the Settings tab.\n3. Click Default Tab.\n4. Select another page from the list.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I change my UMANG app language?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To change the language:\n1.      Click the  icon.\n2.      Click the Settings tab.\n3.      Click Language.\n4.      Select another language from the list.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I increase the font size?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To increase the font size:\n1. Click the  icon.\n2. Click the Settings tab.\n3. Click Font Size.\n4. Select any one of the following options:\n–  Small\n–  Normal\n– Large',
      },
    },
    {
      '@type': 'Question',
      name: 'Why adding email ID to my profile is important?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You should add email ID to your profile to recover your account when you forget your MPIN.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need to logout every time?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, you do not need to logout every time after accessing the app. In case you still wish to log out, you may follow the below steps:\n\nTo logout:\n1. Click the  icon.\n2. Click Logout or you can click the logout button available on the web interface.',
      },
    },
    {
      '@type': 'Question',
      name: 'What does favourite department mean?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'When a department is marked as favourite, it starts appearing in the favourite section.  The Favourite section acts as a repository or dashboard of shortcuts from where users can directly access departments without going through a search and discovery process.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is there any limit on the number of departments I can favourite?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No, there is no limit on the number of departments that you can mark as favourite.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I locate departments?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can locate department’s office address by selecting the View on Map option from the 3 dots  icon placed on the department card and top right corner of the department Home page.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I view information related to the department service?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can view information related to the department service by clicking on the I icon available on the service cards displayed on the department Home page.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I search for a department service?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can search for a department service by entering the service name in the search bar.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are “trending” departments?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Trending departments are the most popular departments that are being used and accessed by most of the people. You can find trending departments on the Home screen in the trending section.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are “New and Updated” departments?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'New and Updated departments  refer to the departments that are updated or added new into the app. You can find New and Updated departments on the Home screen in the new and updated section.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I access departments?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can access departments by clicking on the department cards listed on the Home page of the app. For example, to access CBSE, simply click on the CBSE card and the system redirects you to its main page.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Sort and Filter work on departments?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The filter enables you to view departments based on the selected criteria. Sort enables you to view the department list in alphabetic order.\n\n \nThe Sort and Filter options help in listing the departments on the basis of categorization, type, and alphabetic order.',
      },
    },
    {
      '@type': 'Question',
      name: 'How many languages does the UMANG app support?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG supports 23 shortlisted languages including English and Hindi.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I change my default language?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To change the language:\n1. Click the menu  icon.\n2. Click the Settings tab.\n3. Click Language.\n4. Select the language from the list provided.\n5. Click Ok.',
      },
    },
    {
      '@type': 'Question',
      name: 'I am having trouble with a department, what should I do?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'If you are facing trouble with a department, you can contact the UMANG customer support team at 10505.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I contact the UMANG customer care team?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'If you have any query related to UMANG, you can contact the UMANG Customer Care team using the Phone Support, Email Support and Live Chat options. \nTo contact the UMANG customer care team:\n1. Click the menu icon.\n2. Click Help and support.\n3. Click any one of the following options:\n–  Phone Support: To call the customer care executive.\n–  Email Support: To write to the customer care executive.\n–  Live Chat: To chat with the customer care executive.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I contact the department’s helpdesk?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "If you have some queries related to departments, you can view department information to contact the department's helpdesk.\n\nClick the 3 dots icon on the Home screen to visit the website or connect with the department’s helpdesk.",
      },
    },
    {
      '@type': 'Question',
      name: 'What all queries can be addressed by UMANG customer care?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can contact UMANG customer care to address all your queries related to UMANG app, such as how does the UMANG app work and what all services can be accessed on the UMANG platform.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the different mediums to get support from UMANG customer care team?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can get support from UMANG customer care team using the following options:\nLive chat\nEmail Support\nPhone support',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I email my grievance or concern to customer care?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can contact the UMANG customer care to resolve your queries, grievances and concerns by writing an e-mail to customercare[@]umang[dot]gov[dot]in.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I submit my feedback?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can submit your feedback using the Send Feedback option under the menu icon.\nYou can send feedback related to the following:\nUMANG app\nDepartment and department services.\nOthers',
      },
    },
    {
      '@type': 'Question',
      name: 'I haven’t got a response from UMANG customer care, what should I do?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'UMANG customer support team strives to get your concerns addressed at the earliest. Still, if you haven’t got a response from us. You can contact us using another medium such as:\nLive chat\nEmail support\nPhone support\nIn case you are trying to resolve your issue through email or phone, ensure that you use the correct email address and phone number, respectively.',
      },
    },
  ],
};
